$(document).on('turbolinks:load', function () {
  // ページ読み込み時にモーダル関連の残存要素をクリーンアップ
  const initialBackdrops = document.querySelectorAll('.modal-backdrop');
  initialBackdrops.forEach(backdrop => backdrop.remove());
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');

  // モーダルのアクセシビリティ対応とクリーンアップ
  const modalElement = document.getElementById('share-modal');
  if (modalElement) {
    modalElement.addEventListener('shown.bs.modal', function() {
      modalElement.setAttribute('aria-hidden', 'false');
    });
    
    modalElement.addEventListener('hidden.bs.modal', function() {
      modalElement.setAttribute('aria-hidden', 'true');
      // バックドロップとフォーカス問題の解決
      cleanupModal();
    });
    
    modalElement.addEventListener('hide.bs.modal', function() {
      // モーダルが閉じられ始めた時にフォーカスを適切に管理
      const activeElement = document.activeElement;
      if (activeElement && modalElement.contains(activeElement)) {
        activeElement.blur();
      }
    });
  }

  // 共有モーダルを開く
  $(document).on('click', '[data-share-url]', function(e) {
    e.preventDefault();
    
    // ゲストユーザーの場合など、無効リンクは処理しない
    if ($(this).hasClass('inactive-link')) {
      return;
    }
    
    const shareUrl = $(this).data('share-url');
    const defaultShareText = $('#share-modal').data('default-share-text') || '';
    const shareText = $(this).data('share-text') || defaultShareText;
    
    // URLが空の場合は処理しない
    if (!shareUrl) {
      console.warn('共有URLが設定されていません');
      return;
    }
    
    // QRコードを生成してモーダルに挿入
    generateQRCode(shareUrl);
    
    // モーダルのボタンにURLを設定
    $('#copy-link-btn').data('url', shareUrl);
    
    // プレイヤー選択における招待リンクと、ユーザー招待リンクはx共有ボタンを非表示にする
    if ($(this).hasClass('player-select-invite-link') || $(this).hasClass('player-invite-link')) {
      $('#share-x-btn').hide();
    } else {
      $('#share-x-btn').data('url', shareUrl).data('text', shareText);
    }
    
    // モーダルを表示
    const modalElement = document.getElementById('share-modal');
    const modal = new bootstrap.Modal(modalElement, {
      backdrop: true,     // モーダル外クリックで閉じる
      keyboard: true      // Escキーでも閉じる
    });
    modal.show();
  });

  // リンクコピー機能
  $(document).on('click', '#copy-link-btn', function() {
    const $button = $(this);
    
    // 既にコピー処理中の場合は処理しない
    if ($button.hasClass('copying')) {
      return;
    }
    
    const url = $button.data('url');
    const $span = $button.find('.copy-text');
    const originalText = $span.text();
    
    // コピー処理中フラグを設定
    $button.addClass('copying');
    
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function() {
        showCopySuccessButton($button, $span, originalText);
      }).catch(function(err) {
        console.error('コピーに失敗しました:', err);
        fallbackCopyToClipboard(url, $button, $span, originalText);
      });
    } else {
      fallbackCopyToClipboard(url, $button, $span, originalText);
    }
  });

  // X（Twitter）で共有
  $(document).on('click', '#share-x-btn', function() {
    const url = $(this).data('url');
    const text = $(this).data('text');
    const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank', 'width=550,height=450');
  });

    // QRコード生成関数
  function generateQRCode(url) {
    
    $.ajax({
      url: '/qr_codes',
      method: 'GET',
      data: { url: url },
      success: function(data) {
        $('#qr-code').html(data.qr_code);
      },
      error: function(xhr, status, error) {
        console.error('QRコード生成エラー:', {
          status: xhr.status,
          statusText: xhr.statusText,
          responseText: xhr.responseText,
          error: error
        });
        const qrFailedText = $('#share-modal').data('qr-failed-text') || '';
        $('#qr-code').html($('<p>', { class: 'text-muted' }).text(qrFailedText));
      }
    });
  }

  // ボタンのテキストを一時的に変更
  function showCopySuccessButton($button, $span, originalText) {
    // アイコンを切り替え
    $button.find('.icon-link').addClass('d-none');
    $button.find('.icon-check').removeClass('d-none');

    // テキストを変更
    const copiedText = $('#share-modal').data('copied-text') || '';
    $span.text(copiedText);

    // 2秒後に元に戻す
    setTimeout(function() {
      $button.find('.icon-link').removeClass('d-none');
      $button.find('.icon-check').addClass('d-none');
      $span.text(originalText);
      // コピー処理中フラグを解除
      $button.removeClass('copying');
    }, 2000);
  }

  // フォールバック用コピー機能
  function fallbackCopyToClipboard(text, $button, $span, originalText) {
    const tempInput = document.createElement('input');
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    showCopySuccessButton($button, $span, originalText);
  }

  // モーダルの完全なクリーンアップ
  function cleanupModal() {
    // 残存するバックドロップを強制削除
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
    
    // body要素からBootstrapモーダル関連のクラスを削除
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    
    // X共有ボタンを再表示（次回のモーダル表示のため）
    $('#share-x-btn').show();
    
    // 🚨 CSP修正：HTMLテンプレートリテラルをDOM要素作成に変更
    var $qrLoading = $('<div>', {
      class: 'qr-loading'
    });
    
    var $spinner = $('<div>', {
      class: 'spinner-border text-primary',
      role: 'status'
    });
    
    const qrGeneratingText = $('#share-modal').data('qr-generating-text') || '';
    var $spinnerText = $('<span>', {
      class: 'visually-hidden'
    }).text(qrGeneratingText);

    var $loadingText = $('<small>').text(qrGeneratingText);
    
    $spinner.append($spinnerText);
    $qrLoading.append($spinner, $loadingText);
    $('#qr-code').html($qrLoading);
  }
}); 